export const PdfHighlightAction = {
    Load: "pdf.highlight.load",
    Upsert: "pdf.highlight.upsert",
    Highlight: "pdf.highlight.highlight",
    Delete: "pdf.highlight.delete",
    Select: "pdf.highlight.select",
};
